import React, { useCallback, useContext } from "react";
import * as yup from "yup";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Form } from "react-final-form";
import Validator from "../../../../_helpers/validate.schema";
import { UiCol } from "../../../_uiComponents/grid-container/GridContainer";
import { UiInput, UiInputLink } from "../../../_uiComponents/form/UiInput";
import { getFingerPrint } from "../../../../_helpers/support.services";
import { UiButton } from "../../../_uiComponents/form/UiButton";
import { loginAuthRequest } from "../../../../_redux/_actions";
import UiInlineSuccessMessage from "../../../_uiComponents/form/UiInlineSuccessMessage";
import { Context } from "../../../../_context/Store";

const validateSchema = () =>
    yup.object().shape({
        email: yup
            .string()
            .required("Email is required.")
            .email("Email must be a valid email."),
        password: yup.string().required("Password is required."),
    });

const onValidate = async (values) => {
    return await Validator(values, validateSchema);
};

export default function SingInForm() {
    const actionDispatch = useDispatch();
    const navigate = useNavigate();
    const [state, dispatch] = useContext(Context);

    const submit = async (values) => {
        const browserFingerprint = await getFingerPrint();
        actionDispatch(
            loginAuthRequest({
                ...values,
                browserFingerprint,
                validateOtp: false,
                rememberBrowser: false,
                navigate: navigate,
                requetedUrl : state.requetedUrl
            }),
        );
    };

    return (
        <Form
            onSubmit={submit}
            validate={onValidate}
            render={({ handleSubmit, hasValidationErrors }) => (
                <form onSubmit={validateSchema}>
                    <UiInlineSuccessMessage/>
                    <UiCol lg="12">
                        <UiInput
                            label="Email address"
                            placeholder="Enter your email"
                            type="text"
                            name="email"
                        />
                    </UiCol>

                    <UiCol lg="12">
                        <UiInput
                            label="Password"
                            placeholder="Password"
                            type="password"
                            inputhideicon={true}
                            name="password"
                        />
                    </UiCol>

                    <UiCol lg="12">
                        <UiInputLink
                            text="Forgot your password?"
                            link="/auth/forgot-password"
                            align="right"
                        />
                    </UiCol>

                    <UiCol lg="12">
                        <UiButton
                            className="sb-main-primary-button sb-submit-button"
                            title="Sign in"
                            onClick={useCallback(() => handleSubmit(), [])}
                        />
                    </UiCol>
                </form>
            )}
        />
    );
}
